import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'

const defaultState = {
    open: false,
    term: ''
}

export default createReducer(defaultState, {

    [actions.OPEN_SEARCH]: (state, action) => ({
        ...state,
        open: true
    }),

    [actions.CHANGE_SEARCH_TERM]: (state, action) => ({
        ...state,
        term: action.term
    }),

    [actions.CLOSE_SEARCH]: () => defaultState,

    [actions.VIEW_STOMPUNKT]: () => defaultState,

})



// WEBPACK FOOTER //
// ./src/reducers/search.js